export const QUERY_PARAMS = Object.freeze({
  sessionId: 'session_id',
  secureUserId: 'secure_user_id',
  mobileCheckoutToken: 'mobile_checkout_token',
  promocode: 'promocode',
  passwordResetEmailSent: 'password_reset_email_sent',
  paymentIntent: 'payment_intent',
  userId: 'user_id',
  idToken: 'idToken',
  identifier: 'identifier',
  productId: 'product_id',
  product: 'product',
  sku: 'sku',
  debug: 'debug',
  adid: 'adid',
  idfa: 'idfa',
  idfv: 'idfv',
  appVersion: 'appVersion',
  priceString: 'priceString',
  currencyCode: 'currencyCode',
  price: 'price',
  countryCode: 'countryCode',
  storeCountryCode: 'storeCountryCode',
  isWebRedesignEligible: 'isWebRedesignEligible',
  subscriptionId: 'subscription_id',
  purchaseCode: 'purchase_code',
  referrerSource: 'referrer_source',
  mode: 'mode',
  purchaseType: 'purchase_type',
  checkoutUrl: 'checkout_url',
  skipExistingSubscriptionCheck: 'skip-existing-subscription-check',
  showDuplicateChargeWarning: 'show-duplicate-charge-warning',
  utmSource: 'utm_source',
  subscriptionStartDateMs: 'start-date-ms',
  upgradeProductSku: 'upgrade-product-sku',
  upgradeSubscriptionId: 'upgrade-subscription-id',
  upgraded: 'upgraded',
  subscriptionScheduleId: 'schedule-id',
  debugEnableSubscriptionDelay: 'debug-enable-subscription-delay',
  seriesId: 'series_id',
  episodeId: 'episode_id',
  storyId: 'story_id',
  episodeNumber: 'episode_number',
  testBranch: 'test_branch',
  metadataTestVariantId: 'metadata_test_variant_id',
  metadataTestVariantName: 'metadata_test_variant_name',
  showCookiesBanner: 'show_cookies_banner',
  success: 'success',
  emailVerified: 'email_verified',
  redeemSuccess: 'redeem_success',
  isBundle: 'is-bundle',
  source: 'source',
  /**
   * Encrypted search params to be passed through to the checkout page
   */
  data: 'data',
  externalTransactionToken: 'external_transaction_token',
  checkoutUi: 'checkout_ui',
  webPurchaseCancelled: 'web_purchase_cancelled',
  originalPriceString: 'originalPriceString',
});

export const CHECKOUT_UI_HOSTED = 'hosted';
export const CHECKOUT_UI_EMBEDDED = 'embedded';
export const MOBILE_CHECKOUT_TOKEN_PURPOSE = 'galatea-mobile-hosted-checkout';
export const MOBILE_CHECKOUT_TOKEN_TTL_MS = 24 * 60 * 60 * 1000;
